export default [
    {
      path: '/admin/exchange-rates',
      name: 'exchange-rate',
      meta: { requiresAuth: true },
      component: () => import('@/pages/exchange-rate/index.vue')
    }
  ]
  